import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from '../api';
import './Leaderboard.css';
import { resolveMediaUrl } from '../utils/url';

const Leaderboard = () => {
  const [type, setType] = useState('lifetime');
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [role, setRole] = useState('');
  const [q, setQ] = useState('');
  const [page, setPage] = useState(1);
  const [pageSize] = useState(20);

  useEffect(() => {
    const fetchLeaderboard = async () => {
      setLoading(true);
      try {
        const url = `/users/leaderboard/${type}?role=${role}&q=${q}&page=${page}&pageSize=${pageSize}`;
        const res = await axios.get(url);
        setItems(res.data.items || []);
      } catch (err) {
        setItems([]);
      }
      setLoading(false);
    };
    fetchLeaderboard();
  }, [type, role, q, page, pageSize]);

  return (
    <div style={{ width: '100vw', margin: 0, padding: 0 }}>
      <section style={{ width:'100vw', margin:0, padding:0, position:'relative', left:'-120px' }}>
        <h2 className="hero-title" style={{ textAlign:'center', margin:'0 0 8px' }}>Community Leaderboard</h2>
        <p className="hero-desc" style={{ margin:'0 auto 24px', textAlign: 'center', maxWidth:760 }}>Wer ist aktuell ganz vorne?</p>
      </section>
      <section style={{ width: '100%', display: 'flex', justifyContent: 'center', margin: 0, padding: 0, position:'relative', left:'-120px' }}>
        <div className="leaderboard-container">
          <div className="leaderboard-controls">
            <select value={type} onChange={e => setType(e.target.value)}>
              <option value="lifetime">Lifetime Punkte</option>
              <option value="weekly">Wochenpunkte</option>
            </select>
            <select value={role} onChange={e => setRole(e.target.value)}>
              <option value="">Alle Rollen</option>
              <option value="member">Mitglieder</option>
              <option value="admin">Admins</option>
            </select>
            <input
              type="text"
              placeholder="Suche Nutzer..."
              value={q}
              onChange={e => setQ(e.target.value)}
            />
          </div>
          {loading ? (
            <div>Lade...</div>
          ) : (
            <table className="leaderboard-table">
              <thead>
                <tr>
                  <th>Platz</th>
                  <th>Name</th>
                  <th>Punkte</th>
                </tr>
              </thead>
              <tbody>
                {items.map((user, idx) => {
                  const rank = (typeof user.rank === 'number' && user.rank > 0) ? user.rank : ((page-1)*pageSize + idx + 1);
                  let rowClass = '';
                  let trophy = '';
                  if (rank === 1) { rowClass = 'leaderboard-gold'; trophy = '🥇'; }
                  else if (rank === 2) { rowClass = 'leaderboard-silver'; trophy = '🥈'; }
                  else if (rank === 3) { rowClass = 'leaderboard-bronze'; trophy = '🥉'; }
                  return (
                    <tr key={user.id} className={rowClass} style={rank === 1 ? {fontWeight:'bold',fontSize:'1.15em',background:'#2a2e3a'} : rank === 2 ? {background:'#23272f'} : rank === 3 ? {background:'#23272f'} : {}}>
                      <td>{trophy ? trophy : rank}</td>
                      <td>
                        <img src={resolveMediaUrl(user.avatarUrl && user.avatarUrl.length > 0 ? user.avatarUrl : '/avatars/default-avatar.png')} alt="avatar" className="avatar" />
                        <Link to={`/u/${user.id}`} style={{color:'#32CD89',textDecoration:'none',fontWeight:'bold'}}>
                          {user.displayName || user.username}
                        </Link>
                      </td>
                      <td>{type === 'lifetime' ? user.UserPoint?.points ?? 0 : user.UserWeeklyPoint?.points ?? 0}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          )}
          <div className="leaderboard-pagination">
            <button disabled={page === 1} onClick={() => setPage(page-1)}>Zurück</button>
            <span>Seite {page}</span>
            <button disabled={items.length < pageSize} onClick={() => setPage(page+1)}>Weiter</button>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Leaderboard;
